import { LazyImport, LazyModule, preloadScriptChunk } from 'owa-bundling';
export { FocusedViewFilter }; // import/export of this just to make typescript happy
export { ActivityType };
preloadScriptChunk('InferenceTracking');
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "InferenceTracking" */ './lazyIndex');
});
/**
 * This is the function consumers should call when preparing data to log to inference API
 * via @see logCustomDataLoggerDatapoint or @see logUsage.
 * Note that inference APIs do not care about conversationIds -- they do not help train the
 * inference model and will be discarded! -- so you must first make a call to grab itemIds.
 * To prevent any bias in the data from lazy loading, you will also need to make the activity
 * time call inline. You can just copy: new Date().toISOString()
 */
export var lazyBuildInferenceDatapoint = new LazyImport(lazyModule, function (m) { return m.buildInferenceDatapoint; });
//# sourceMappingURL=index.js.map